import { Fragment } from "react";

/**
 * An IP address that may wrap only after a ":", so IPv6 fits a narrow cell and IPv4 never
 * breaks. `overflow-wrap: anywhere` would instead let a table squeeze IPv4 mid-octet.
 */
export default function IpText({ ip }: { readonly ip: string }) {
  const groups = ip.split(":");
  return (
    <>
      {groups.map((group, i) => (
        // The groups of one address never reorder, so the position is a stable key.
        <Fragment key={i}>
          {group}
          {i < groups.length - 1 && (
            <>
              :<wbr />
            </>
          )}
        </Fragment>
      ))}
    </>
  );
}
